export default __webpack_public_path__ + "locales/sk/PeopleTranslations.json?hash=c5beafa6be3c6ce493097c22b85e95af";